import React, { Component } from 'react';
import SEO from '../../components/SEO';
import snippetsData from '../../data/snippetsData';
import Layout from '../../layout';
import SnippetCatalog from './_catalog';

class Page extends Component {
  render() {
    return (
      <Layout>
        <SEO
          title="Polypane Snippets Store"
          description="Find CSS and JS snippets and create your own collections to add custom functionality to Polypane."
          keywords={['']}
          pathname={this.props.location.pathname}
        />
        <SnippetCatalog snippets={snippetsData} />
      </Layout>
    );
  }
}

export default Page;
